<template>
  <div class="wordpress page">
    <subpage-layout :theme="'light'" :name="this.$route.name">
      <template v-slot:hero-image>
        <img src="../assets/img/hero-img-3.jpg" />
      </template>
      <template v-slot:hero-title>Wordpress</template>
      <template v-slot:description>
        <h2>Wordpress</h2>

        <p>
          <strong>
            One of the highlights of last year was designing and styling a new
            WordPress custom theme for our blog.
          </strong>
        </p>
        <p>
          After working almost exclusively on very content-heavy Drupal sites
          for years it was a nice change to see what Wordpress can do and how it
          does it.
        </p>
        <p>
          Wordpress impressed me with its
          <strong>flexibility, lightness and lovely new editor</strong>.
        </p>
      </template>
      <template v-slot:skills>
        <featured-temp :kind="'sm'">
          <template v-slot:featured-title>Skills</template>
          <template v-slot:default>
            <ul>
              <li>Wordpress</li>
              <li>PHP</li>
              <li>Javascript</li>
              <li>SCSS</li>
              <li>CSS</li>
              <li>Bootstrap</li>
            </ul>
          </template>
        </featured-temp>
      </template>

      <template v-slot:pics>
        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/blog-header.png" alt />
          </template>
          <template v-slot:label>
            <p>Here is a homepage desktop view screenshot detail</p>
          </template>
        </project-picture>

        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/blog_middle.png" alt />
          </template>
          <template v-slot:label>
            <p>Homepage desktop view screenshot detail</p>
          </template>
        </project-picture>

        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/blog_cards.png" alt />
          </template>
          <template v-slot:label>
            <p>Content type cards - desktop view</p>
          </template>
        </project-picture>

        <div class="mrow margin">
          <div class="mcol">
            <project-picture>
              <template v-slot:pic>
                <img src="../assets/img/blog_cards_md.png" alt />
              </template>
              <template v-slot:label>
                <p>Content type cards - tablet view</p>
              </template>
            </project-picture>
          </div>
          <div class="mcol">
            <project-picture>
              <template v-slot:pic>
                <img src="../assets/img/blog_cards_sm.png" alt />
              </template>
              <template v-slot:label>
                <p>Content type cards - mobile view</p>
              </template>
            </project-picture>
          </div>
          <div class="mcol">
            <project-picture>
              <template v-slot:pic>
                <img src="../assets/img/blog_cards_xs.png" alt />
              </template>
              <template v-slot:label>
                <p>Content type cards - xs</p>
              </template>
            </project-picture>
          </div>
        </div>
      </template>
    </subpage-layout>
  </div>
</template>

<script>
import subpageLayout from "@/components/SubpageLayout";
import featuredTemp from "@/components/FeaturedTemp";
import projectPicture from "@/components/ProjectPicture";
export default {
  name: "wordpress",
  components: {
    subpageLayout,
    featuredTemp,
    projectPicture
  },
};
</script>

<style></style>
